// формат масок под отдельные страны
export const masks = {
	ae: '+... ... ... ...',
	zw: '+... ... ... ... ...',
};
